import React, { memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { STAGES_MAP } from 'redux/modules/journeys/stop-status-log';

const t = {
  arrived: 'Arrived at',
  unloaded: 'Unloaded at',
  loaded: 'Loaded at',
  started: 'Started at',
  timeFormat: 'HH:mm',
  dateFormat: 'DD/MM',
};

const formatDoneTitle = {
  [STAGES_MAP.PENDING]: () => {
    return t.arrived;
  },
  [STAGES_MAP.ONROUTE]: () => {
    return t.started;
  },
  [STAGES_MAP.DONE]: (stopType) => {
    return stopType === 'DROPOFF' ? t.unloaded : t.loaded;
  },
};

const formatTimeDone = (time) => {
  return time ? moment(time).format(t.timeFormat) : time;
};

const formatDateDone = (date) => {
  return date ? moment(date).format(t.dateFormat) : date;
};

const isSameDate = (time, stopTimeFrom) => {
  return moment(stopTimeFrom).startOf('day').diff(moment(time).startOf('day'), 'day') === 0;
};

const StageTime = ({ className, stage, stopType, time, stopTimeFrom }) => {
  if (!time) {
    return null;
  }

  const timeDoneFormatted = formatTimeDone(time);
  let dateDoneFormatted = '';

  if (!isSameDate(time, stopTimeFrom)) {
    dateDoneFormatted = formatDateDone(time);
  }

  const title = !!timeDoneFormatted
    ? `${formatDoneTitle[stage](stopType)} ${timeDoneFormatted} ${dateDoneFormatted}`
    : '';

  return (
    <div title={title} className={className}>
      <span>{timeDoneFormatted}</span>
      {dateDoneFormatted && <span className="date">{dateDoneFormatted}</span>}
    </div>
  );
};

StageTime.propTypes = {
  className: PropTypes.string,
  stage: PropTypes.string,
  stopType: PropTypes.string,
  time: PropTypes.string,
};

export default memo(StageTime);
